package br.com.texeratx.boardgametimeapp.data.repository

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.data.model.login.ForgotPasswordRequest
import br.com.texeratx.boardgametimeapp.data.model.login.LoginRequest
import br.com.texeratx.boardgametimeapp.data.model.login.LoginResponse
import br.com.texeratx.boardgametimeapp.data.model.login.MessageResponse
import br.com.texeratx.boardgametimeapp.data.model.login.ResetPasswordRequest
import br.com.texeratx.boardgametimeapp.data.model.login.SignupRequest
import io.github.aakira.napier.Napier
import io.ktor.client.call.body
import io.ktor.client.statement.HttpResponse

class LoginRepository(
    private val api: ApiClient
) {

    suspend fun login(email: String, password: String): LoginResponse {
        Napier.d("LoginRepository → iniciando login para email: $email")

        val request = LoginRequest(email, password)

        val httpResponse: HttpResponse = api.post("auth/login", request)

        val dto: LoginResponse = httpResponse.body()

        Napier.d("LoginRepository → login OK, token recebido")

        return dto
    }

    suspend fun signup(email: String, password: String, displayName: String): LoginResponse {
        Napier.d("LoginRepository → iniciando signup para email: $email")

        val request = SignupRequest(
            email = email,
            password = password,
            displayName = displayName
        )

        val httpResponse: HttpResponse = api.post("auth/signup", request)
        val dto: LoginResponse = httpResponse.body()

        Napier.d("LoginRepository → signup OK, token recebido")

        return dto
    }

    suspend fun forgotPassword(email: String): MessageResponse {
        Napier.d("LoginRepository → iniciando forgot-password para email: $email")

        val httpResponse: HttpResponse = api.post("auth/forgot-password", ForgotPasswordRequest(email))
        val dto: MessageResponse = httpResponse.body()

        Napier.d("LoginRepository → forgot-password OK")

        return dto
    }

    suspend fun resetPassword(email: String, code: String, newPassword: String): MessageResponse {
        Napier.d("LoginRepository → iniciando reset-password")

        val httpResponse: HttpResponse = api.post(
            "auth/reset-password",
            ResetPasswordRequest(email = email, code = code, newPassword = newPassword)
        )

        val dto: MessageResponse = httpResponse.body()

        Napier.d("LoginRepository → reset-password OK")

        return dto
    }
}
